const Lang = {
  "global.networkerror": "网络不通，请稍后再试",
  "global.loading": "加载中...",

  "global.fa": "فارسی",
  "global.zh": "中文",
  "global.en": "English",
  "global.ja": "日文",

  cancel: "取消",
  confirm: "确认",

  BSV: "BSV",
  BTC: "BTC",
  LATEST: "最新",

  "unit.set": "台",

  /**
   * 关于我们介绍 --- start
   */
  "about.us": "关于我们",
  "mempool.about.p1":
    "Mempool 创立于2018年11月，是一个为用户提供 BTC 和 BSV 挖矿服务的比特币矿池，同时也是全国领先的 BSV 矿池。凭借 AsicBoost 技术，大幅度降低能耗，提升采矿效率，为用户出创造更高更多的收益。",
  "mempool.about.p2":
    "“实时矿机监测、自动切换币种、矿池自动打款、用户收益透明”，Mempool 相信原始比特币白皮书中描述的中本聪愿景，致力于打造安全稳定的数字矿池货币。",
  "mempool.about.p3":
    "如今，Mempool 已开通 Web 端，Android 端入口，未来将陆续开放 IOS 端口，为用户提供随时随地、高效透明的矿池服务。",
  "mempool.about.company": "博泉网络",
  "mempool.about.p4":
    "博泉网络是一家专注区块链领域的科技创新公司，致力于区块链和数字货币的互联网产品研发，团队创始人均拥有10年以上研发经验，荣获过谷歌顶尖开发者（Google-Top-Developer）称号，涵盖了多年 BAT 经验互联网老兵、最早一批区块链爱好者、精通深度算法的技术人员等。",
  "mempool.about.p5":
    "目前，公司已拥有丰富的产品线：打点钱包——针对 BSV 打造的轻量级钱包应用；Mempool 矿池——国内领先的 BTC/BSV 挖矿服务的比特币矿池；区块链浏览器——支持 BTC/BSV 查询的区块链浏览器，以及云算力平台等。",
  "mempool.about.p6":
    "博泉网络旨在不断地探索应用区块链技术，打造健康的生态闭环，携手比特币一同改变世界。",

  "nourpool.about.p1":
    "Nourpool是新生代的先进BSV/BTC矿池，为矿工提供创新的服务模式，行业领先的稳定性，以及卓越的用户体验。",
  "nourpool.about.p2":
    "Nourpool由资深矿工，前微软开发者和前百度开发者组成的团队与2019年10月在深圳成立。Nourpool致力于实现中本聪愿景，将在矿池服务上进行前沿探索，并将于2020年推出更多服务于比特币SV生态的专业服务，敬请期待。",

  "exatoshi.about.p1":
    "exatoshi 创立于2018年11月，是一个为用户提供 BTC 和 BSV 挖矿服务的比特币矿池，同时也是全国领先的 BSV 矿池。凭借 AsicBoost 技术，大幅度降低能耗，提升采矿效率，为用户出创造更高更多的收益。",
  "exatoshi.about.p2":
    "“实时矿机监测、自动切换币种、矿池自动打款、用户收益透明”，exatoshi 相信原始比特币白皮书中描述的中本聪愿景，致力于打造安全稳定的数字矿池货币。",
  "exatoshi.about.p3":
    "如今，exatoshi 已开通 Web 端，Android 端入口，未来将陆续开放 IOS 端口，为用户提供随时随地、高效透明的矿池服务。",
  /**
   * 关于我们介绍 --- end
   */

  "miner.china": "中国",
  "miner.europe": "欧洲",
  "miner.usa": "美国",
  "miner.example": "矿工名设置样:",
  "miner.address": "挖矿地址",

  // login
  login: "登录",
  poolLogin: "矿池账号登录",
  dotLogin: "登录",
  dotRegister: "注册打点钱包账户",
  register: "注册",
  forgetPassword: "忘记密码",
  withdrawToWeb: "提现至打点钱包-网页版",
  withdrawNewAddress: "提现到新地址",
  reset: "重置",
  returnToLogin: "返回登录",
  //
  newPassword: "新密码，8-16位",
  rePassword: "确认密码",
  next: "下一步",
  enterCode: "请输入验证码",
  getCode: "获取验证码",
  loginType: "注册的手机号或邮箱",
  goLogin: "返回登录",
  forgetSuccess: "密码重置成功",
  NoMailTips: "若未收到验证码，可能被运营商加入黑名单，请联系客服",
  passwordPlaceholder: "8-16位密码，需包含数字、字母和特殊字符",
  phonePlaceholder: "请输入手机号或邮箱",
  registerSuccess: "注册成功",
  UserAgreement: "用户协议",
  PrivacyPolicy: "隐私政策",
  SignAgreement: "点击“立即注册”即表示同意",
  imgAlt: "",
  NoAccount: "没有账号？",
  HaveAccount: "已有账号？",
  NowLogin: "立即登录",
  NowRegister: "立即注册",
  LoginBannerTitle1: "更好的",
  LoginBannerTitle2: "比特币挖矿体验",
  LoginBannerTip: "更多收益 安全稳定",

  "meta.homeTitle": "Mempool矿池-全球收益领先的BSV/BTC/BCH的比特币矿池",
  "meta.homeDescription":
    "Mempool矿池全网收益第一，提供BSV/BTC/BCH矿池挖矿服务，实现您轻松挖矿，为您收益保障护航。",
  "meta.homeKeyword": "比特币矿池、BSV矿池",

  // 账户设置
  "LoginLog.Title": "登入记录",
  "LoginLog.TitleTip": "仅显示最近5次登入记录，查看更多记录请联系客服",
  "LoginLog.TableTime": "登入时间",
  "LoginLog.TableCity": "登入城市",
  "LoginLog.TableIP": "登入IP",
  "LoginLog.Security": "安全设置",
  "LoginLog.Password": "登入密码",
  "LoginLog.GoogleTitle": "Google验证码",
  "LoginLog.Open": "已开启",
  "LoginLog.Closed": "已关闭",
  "LoginLog.weChatQRCode": "二维码",
  "LoginLog.weChat": "微信公众号",
  "LoginLog.weChatTips": "关注微信公众号，绑定矿池账号，实时获取消息通知",
  "LoginLog.CodeTip": "提升账户安全性，登入、提现、设置收款地址时，您还需要输入一个6位数的验证码",
  "LoginLog.OtherSetting": "其他设置",
  "LoginLog.ChooseTime": "时区选择",
  "LoginLog.ChangePassword": "修改密码",
  "LoginLog.OldPassword": "原密码",
  "LoginLog.NewPassword": "新密码",
  "LoginLog.ConfirmNewPassword": "确认新密码",
  "LoginLog.On": "开启Google验证",
  "LoginLog.Off": "关闭Google验证",
  "LoginLog.Section1": "1、安装Goolge验证器到您的手机（Apple、Android）",
  "LoginLog.Section2": "2、打开Goolge验证器，点击“添加用户”-“扫描二维码”。",
  "LoginLog.Section3": "3、扫描屏幕上的二维码，请备份好该二维码。",
  "LoginLog.Section4": "4、输入app上显示的6位数字。",
  "LoginLog.key": "秘钥",
  "LoginLog.InputPlaceholder": "请输入6位google验证码",
  "LoginLog.CloseTip": "关闭Google验证会增大您的账户风险，不利于您的账户财产安全",
  "LoginLog.SuccessTip": "登入、提现、设置收款地址时都需要输入6位验证码",
  "LoginLog.SuccessText": "绑定成功",
  "LoginLog.CloseTitle": "Google验证已关闭",
  "LoginLog.OpenAgain": "您可以随时再次开启Google验证码功能",

  //资金管理
  "fund.accountAddressTipsBTC": "使用主账户BTC收款地址",
  "fund.accountAddressTips": "使用主账户收款地址",
  "fund.LastModifiedTime": "上次修改时间	",
  "fund.Set": "设 置",
  "fund.NoWithdraw": "不自动提款",
  "fund.Daily": "每日提款",
  "fund.tipsLeft": "余额>=",
  "fund.tipsRight": "时，每日UTC+8 14:00自动提款到提现地址",
  "fund.tipsBTCLeft": "余额>=",
  "fund.tipsBTCRight": "BTC时，每日UTC+8 14:00自动提款到提现地址",
  "fund.tipsBSVLeft": "余额>=",
  "fund.tipsBSVRight": "BSV时，每日UTC+8 14:00自动提款到提现地址",
  "fund.Save": "保存",
  "fund.Cancel": "取消",
  "fund.BTCToBSV": "BTC换BSV",
  "fund.noExchange": "不自动换币",
  "fund.dailyExchange": "每日自动换币",
  "fund.moneyExchange": "按金额自动换币",
  "fund.time": "次",
  "fund.day": "日",
  "fund.MinExchange": "最小兑换额为0.01BTC",
  "fund.ExTime": "执行时间 (UTC+8)",
  "fund.SubAccount": "子账户",
  "fund.Balance": "余额",
  "fund.Address": "提现地址",
  "fund.Operation": "操作",
  "fund.BTCButton": "提现BTC",
  "fund.BSVButton": "提现BSV",
  "fund.BTCTOBSV": "一键换币",
  "fund.Monthly_bill": "月账单查看",
  "fund.WithdrawAddress": "收款地址设置",
  "fund.setWithdraw": "自动提款设置",
  "fund.ExchangeSetting": "一键换币设置",
  "fund.Last24hours": "昨日收益",
  "fund.Cumulative": "累计收益",
  "fund.TreasuryCurrent": "共享费率资金",
  "fund.Detail": "详情",
  "fund.Exchange": "每次兑换",
  "fund.BTCtopTips": "不要填写BTC以外的地址或手机号码，以免提现至错误地址",
  "fund.BSVtopTips": "不要填写BSV legacy以外的地址或手机号码，以免提现至错误地址",
  "fund.NoMailTips": "若未收到验证码，可能被运营商加入黑名单，请联系客服",
  "fund.NoAddress": "暂未设置地址",
  "fund.Current": "当前",
  "fund.SameAccount": "与主账户一致",
  "fund.dayChange": "每日兑换",
  "fund.Mining": "挖矿",
  "fund.MonitorAlarm": "监控警报",
  "fund.Watcher": "观察者",
  "fund.none": "暂无数据",
  "fund.BalanceTips": "所有账户可提现余额总合",
  "fund.CumulativeTips": "所有账户获得的累计收益总合",
  "fund.AddressTips1": "BTC/BSV提现时使用的地址",
  "fund.AddressTips2": "新创建的子账户将默认使用此地址",
  "fund.AddressTips3": "不同子账户可以在【子账户】-【设置】中设置不同的提现地址",
  "fund.setWithdrawTips1": "BTC/BSV可分别设置自动提现",
  "fund.setWithdrawTips2": "新创建的子账户将默认使用此设置",
  "fund.setWithdrawTips3": "不同子账户可以在【子账户】-【设置】中设置不同的自动提现方式",
  "fund.ExchangeSettingTips1": "目前支持将BTC兑换为BSV",
  "fund.ExchangeSettingTips2": "新创建的子账户将默认使用此设置",
  "fund.ExchangeSettingTips3": "不同子账户可以在【子账户】-【设置】中设置不同的兑换方式",
  "fund.AutoWithdrawDayTip": "每日兑换一次，账户BTC余额到达设置金额时，全部自动兑换为BSV ",
  "fund.AutoWithdrawTimeTip": "按次兑换，账户BTC余额到达设置金额时，全部自动兑换为BSV",
  "fund.MonitorOpen": "监控已开启",
  "fund.MonitorClose": "监控未开启",
  "fund.moreHeigher": "收益较高，",
  "fund.better": "更好",

  //共享费率
  "treasury.HandleFee": "出块-手续费",
  "treasury.Deposit": "注资",
  "treasury.Withdrawal": "提款",
  "treasury.PaymentFPPS": "支付-FPPS",
  "treasury.BlockReward": "出块-块奖励",
  "treasury.ColdWallet": "冷钱包转出",
  "treasury.HotWallet": "热钱包转入",
  "treasury.FundsFallback": "资金回退",
  "treasury.PayingFPPS": "正在支付-FPPS",
  "treasury.PaymentBTC": "支付-BTC算力",
  "treasury.LockReward": "出块-冻结块奖励",
  "treasury.ToBeConfirm": "待确认",
  "treasury.Refuse": "拒绝转账",
  "treasury.Confirm": "已确认",

  "treasury.Processing": "处理中",
  "treasury.Paid": "已支付",
  "treasury.PerHour": "每小时",
  "treasury.PerMinute": "每分钟",
  "treasury.PerDay": "每天",
  "treasury.ExchangeEchart": "BSV资金池走势",
  "treasury.ChangePoolRecord": "资金池变动记录",
  "treasury.ChangePoolRecordTip": "资金池支付矿工、出块收取块奖励的记录",
  "treasury.RecordList": "查看我的投资记录",
  "treasury.All": "查看全部记录",
  "treasury.ChangeType": "变动类型",
  "treasury.Time": "时间",
  "treasury.Amount": "金额",
  "treasury.BlockInfo": "备注",
  "treasury.Height": "高度",
  "treasury.Conf": "确认数",
  "treasury.DepositBSV": "注资BSV",
  "treasury.WithdrawalBSV": "提款BSV",
  "treasury.Record": "投资记录",
  "treasury.DepositHistroy": "注资记录",
  "treasury.WithdrawHistroy": "提款记录",
  "treasury.Status": "状态",
  "treasury.TXID": "交易ID",
  "treasury.More": "全部",
  "treasury.Mine": "我的",
  "treasury.Investment income": "我的投资收益",
  "treasury.Proportion": "我的投资占比",
  "treasury.Lock BSV": "冻结中BSV",
  "treasury.Tips": "新出块需在100个确认数后划转至账户。",
  "treasury.EarnTips": "已包含冻结中金额",
  "treasury.Exchangerate": "汇率走势",
  "treasury.Progress": "确认进度",
  "treasury.address": "注资地址",
  "treasury.Present Value": "我的资金余额",
  "treasury.Current Treasury": "资金池总额",

  "treasury.MyBalance": "我的资金余额快照",
  "treasury.MyBalanceTip": "资金余额 = 注资总额 + 已解冻收益 - 支付矿工金额 - 历史提现总额",
  "treasury.PoolBalance": "共享费率资金快照",
  "treasury.Blocks": "出块统计",
  "treasury.BSVBlocks": "BSV出块数",
  "treasury.PersonalRecord": "我的资金变动记录",
  "treasury.PoolRecord": "共享费率资金变动记录",
  "treasury.percent": "提现百分比",
  "treasury.percentAmount": "预计提现金额",
  "treasury.sevenDay": "7天",
  "treasury.mounth": "30天",
  "treasury.3mounth": "90天",
  "treasury.6mounth": "180天",
  "treasury.all": "全部",

  fees: "电费",
  machineName: "矿机型号",
  power: "算力",
  consumption: "功耗",
  "Unit power consumption": "单位算力功耗",
  "Daily output": "日产出",
  "Daily electricity fee": "日电费",
  "Electricity cost ratio": "电费占比",
  "Net profit/T/day": "净利润/T/天",
  "payback period": "回本周期",
  "login.miner": "选择矿机 ",
  "login.input": "输入价格 ",
  "login.payoff": "天回本",
  "login.rank": "矿机收益榜",
  "login.update": "数据更新时间",
  "login.dayEarn": "挖矿日收益",
  "login.okex": "币价截取每日北京时间8时的okex交易所价格",
  "login.totalPower": "矿池总算力",
  "login.dailyEarn": "日收益PPS/T",

  "login.appText1": "查看多账户挖矿详情,  查看收益，手动提现",
  "login.appText2": "矿机查看，分组管理，查看在线情况",
  "login.appText3": "子账户设置",
  "login.appText4": "观察者只读账户查看",
  "login.IOS": "iOS版下载",
  "login.Android": "Android版下载",

  "login.InfoTitle": "更懂你的矿池",
  "login.Info1": "支持手动提现",
  "login.Info1_text": "任意时刻进行手动提现，牛市机遇不错过",
  "login.Info2": "智能托管",
  "login.Info2_text": "自动选择更高收益币种挖矿，相同算力更多收益支持BTC/BSV切换",
  "login.Info3": "0手续费",
  "login.Info3_text": "加入矿池共享费率计划，手续费可低至0，更可以与矿池共享收益",
  "login.Info4": "服务一流",
  "login.Info4_text": "专业矿池运维团队，7*24全天候不间断服务，保证矿池稳定运行，收益不掉线。",

  "login.FAQ": "常见问答",
  "login.Q1": "如何手动提款？",
  "login.A1_1": "在收益页面，点击提款按钮即可发起手动提款。",
  "login.A1_2": "手动提款提交成功后，将会尽快为您发起转账。",
  "login.Q2": "自动提款起付额分别是多少？",
  "login.A2_1": "BTC自动提款起付额为0.01 BTC",
  "login.A2_2": "BSV自动提款起付额为0.001 BSV",
  "login.A2_3": "BTC和BSV都支持自定义起付额",
  "login.Q3": "为什么挖矿收益会有变化？",
  "login.A3":
    "比特币全网难度每过2016个区块都会略有一些变化，矿工在保持原来算力的情况下,收益略微涨跌是正常的。",
  "login.Q4": "为什么还没有收到挖矿收益？",
  "login.A4":
    "挖矿收益每天支付一次。矿池会在北京时间上午08:00-12:00左右支付前一结算日（北京时间当日上午8点至前一日上午8点）的挖矿收益，您可以前往收益页面查看。",

  // Heard
  "Header.dropdown.set": "账号设置",
  "Header.dropdown.exit": "退出",
  "Header.Dashboard": "用户面板",
  "Header.ShareFees": "共享费率",
  "Header.AgentManagement": "代理管理",
  "Header.AgentCreate": "代理创建",
  "Header.Tools": "工具",
  "Header.Report": "报表",
  "Header.Watcher": "观察者面板",
  "Header.Money": "资金管理",
  "Header.More": "更多",

  // footer
  "Footer.Products": "产品",
  "Footer.Pool": "Mempool",
  "Footer.Lastpurse": "打点钱包",
  "Footer.Help": "帮助中心",
  "footer.MiningSet": "挖矿配置",
  "Footer.Notice": "最新公告",
  "Footer.Guide": "用户指南",
  "Footer.Feedback": "工单反馈",
  "Footer.Aboutus": "关于我们",
  "Footer.Cooperation": "商务合作",
  "Footer.CustomerServices": "客服中心",
  "Footer.Links": "联系我们",
  "Footer.AddWeChat": "客服微信",
  "Footer.copy": "复制",
  "Footer.QQGroup": "QQ群",
  "Footer.Android": "Android版",
  "Footer.Link": "友情链接",
  "Footer.Blockchain": "区块链网址导航",
  "Footer.blockchair": "Blockchair",
  "Footer.recordNumber": "闽ICP备18005066号-3",

  //IndexPage
  "SubTab.Earning": "收益记录",
  "SubTab.Withdraw": "提现记录",
  "SubTab.Changetab": "换币记录",
  "SubTab.Switch": "智能切换记录",
  "SubTab.BSV2BTC": "BSV自动兑换BTC记录",
  "IndexPage.Redeem": "兑换到BTC",
  "IndexPage.history": "兑换记录",
  "SubTab.ExportTable": "导出",
  "Notice.More": "查看全部",
  "IndexPage.totalHashrates": "总算力",
  "IndexPage.totalHashratesTips": "所有子账户算力汇总数据",
  "IndexPage.SubHashratesTips": "当前子账户算力汇总数据",
  "IndexPage.realTime": "实时",
  "IndexPage.hour24": "今日",
  "IndexPage.totalMiners": "总矿工",
  "IndexPage.totalMinersTips1": "所有子账户矿工汇总数据",
  "IndexPage.SubMinersTips1": "当前子账户矿工汇总数据",
  "IndexPage.totalMinersTips2": "正常：平稳运行的矿工",
  "IndexPage.totalMinersTips3": "低速：单个矿工的实时算力连续5次低于额定算力/24小时算力的80%",
  "IndexPage.totalMinersTips4": "离线：矿工30分钟没有提交新的shares",
  "IndexPage.online": "正常",
  "IndexPage.onlineTip": "在线矿工 = 正常 + 低速",
  "IndexPage.low": "低速",
  "IndexPage.offline": "离线",
  "IndexPage.Last24hours": "昨日收益",
  "IndexPage.BTC": "BTC",
  "IndexPage.BSV": "BSV",
  "IndexPage.Last24hoursTips": "昨日收益为UTC 0:00-24:00（北京时间昨日8:00-今日8:00）的收益",
  "IndexPage.todayEstimate": "今日预估",
  "IndexPage.todayEstimateTip":
    "今日预计可以获得的收益，受到矿机运行情况和市场难度影响，请以实际收益为准",
  "IndexPage.list": "子账户列表",
  "IndexPage.addAccount": "创建子账户",
  "IndexPage.NewSubAccount": "新增子账户",
  "IndexPage.accountName": "请输入全新的子账户名",
  "IndexPage.chooseCoin": "初始挖矿币种:",
  "IndexPage.Earning": "收益预估(1Px24h)",
  "IndexPage.Higher": "更高",
  "IndexPage.Submit": "确认",
  "IndexPage.Cancel": "取消",
  "IndexPage.Account": "子账户名",
  "IndexPage.MinersOnOff": "矿工(正常/低速/离线)",
  "IndexPage.RealTime": "实时算力",
  "IndexPage.RealTimeTips": "近15分钟的平均算力",
  "IndexPage.24hour": "24小时算力",
  "IndexPage.24hourTips": "最近24小时的平均算力",
  "IndexPage.dailyPower": "日平均算力",
  "IndexPage.dailyPowerTips": "当日的平均算力",
  "IndexPage.CoinType": "币种",
  "IndexPage.change": "智能切换",
  "IndexPage.On": "开",
  "IndexPage.Off": "关",
  "IndexPage.changeTips": "选择的收益币种",
  "IndexPage.coinEarn": "选择的收益币种，矿池将使用智能切换为用户带来更多的收益",
  "IndexPage.Balance": "余额",
  "IndexPage.Detail": "详情",
  "IndexPage.chartList": "统计图表",
  "IndexCharts.24hour": "24小时",
  "IndexCharts.7day": "7天",
  "IndexCharts.mounth": "1月",
  "IndexCharts.3mounth": "3月",
  "IndexCharts.6mounth": "半年",
  "IndexCharts.year": "一年",
  "IndexCharts.all": "全部",
  "IndexCharts.PerHour": "每小时",
  "IndexCharts.PerDay": "每天",
  "IndexCharts.power": "算力",
  "IndexCharts.miner": "在线矿工",
  "IndexCharts.income": "收益",
  "IndexCharts.Hashrate": "算力有波动？",
  "IndexPage.Optional": "自选",
  "IndexPage.miner": "矿工",
  "IndexPage.totalMiner": "总在线矿工",
  "IndexPage.totalEarn": "总收益",
  "IndexPage.setTriggerValue": "设置触发值",
  "IndexPage.IncomeHeigher": "切换时收益差值",
  "IndexPage.longTime": "持续时长",
  "IndexPage.switchDeriction": "切换方向",
  "IndexPage.Ongoing": "持续中",
  "IndexPage.mainEarnTip": "所有子账户收益汇总数据",
  "IndexPage.Estimate": "预估",
  "IndexPage.Repayment Record": "联合挖矿记录",
  "IndexPage.ChargeData Record": "费用代扣",
  "IndexPage.Update": "更新日期",
  "IndexPage.DailyBack": "日收入",
  "IndexPage.Accumulated Repayment": "总收入",
  "IndexPage.Minus digital currency": "扣除数字货币",
  "IndexPage.Price per day": "币价",
  "IndexPage.PriceInfo": "okex交易所每日北京时间8点的交易价格",
  "IndexPage.chargeInfo": "扣费时交易所实时价格",
  "IndexPage.standard": "标准",
  "IndexPage.smart": "智能",
  "IndexPage.management": "管理",
  "IndexPage.hidden": "隐藏",
  "IndexPage.show": "显示",

  // CustomerServices
  "CustomerServices.Customer_Services": "客服中心",
  "CustomerServices.Contact_Us": "联系客服",
  "CustomerServices.Que": "缺缺",
  "CustomerServices.XiaoMing": "小明",
  "CustomerServices.Xing": "小星",
  "CustomerServices.tel": "Tel：",
  "CustomerServices.Email": "Email：",
  "CustomerServices.Online_Time": "在线时间：工作日10:00-19:00",
  "CustomerServices.Email_us_or_Message":
    "非工作日请发送邮件或微信留言，我们将在工作日第一时间回复您。",
  "CustomerServices.Follow_Us": "关注我们",
  "CustomerServices.QQ": "官方QQ群：",
  "CustomerServices.wx": "关注微信公众号",

  // SubSettingObserver
  "SubSettingObserver.WatcherSetting": "观察者设置",
  "SubSettingObserver.WatcherAccount": "观察者账户",
  "SubSettingObserver.WatcherPlaceholder": "请输入要添加的完整观察者主账户名",
  "SubSettingObserver.AddedAccount": "已添加的账户",
  "SubSettingObserver.ShareLink": "共享链接",
  "SubSettingObserver.WatcherTipsLeft": "观察者可以通过以上链接查看",
  "SubSettingObserver.WatcherTipsRight": "的数据，但无法操作、修改你的子账户",
  "SubSettingObserver.Set": "设置",
  "SubSettingObserver.AuthorizedAccount": "已授权账户",
  "SubSettingObserver.Close": "关闭",
  "SubSettingObserver.None": "无",
  "SubSettingObserver.DeleteText": "确定删除授权账户 ",
  "SubSettingObserver.CopySuccess": "复制成功",
  "SubSettingObserver.ObserverLink": "复制观察者链接",
  "SubSettingObserver.Ok": "确定",

  "NoData.Text": "空空如也~ 暂无数据~",

  Back: "返回",
  Home: "首页",

  //IndexPage
  "IndexPage.FrozenMoney": "冻结金额",
  "IndexPage.FrozenTips1": "fpplns所得收益，将暂时冻结，",
  "IndexPage.FrozenTips2": "需要经过100个确认数后到账",
  "IndexPage.Repayment": "联合挖矿金额",

  "IndexPage.earning.MiningDate": "挖矿日期",
  "IndexPage.earning.MiningDateTips1": "收益账单生成的日期为北京时间每日8点",
  "IndexPage.earning.MiningDateTips2": "挖矿日期为UTC时间",
  "IndexPage.earning.Hashrate": "每日算力",
  "IndexPage.earning.HashrateTips": "挖矿日期的平均算力值",
  "IndexPage.earning.settleWay": "结算方式",
  "IndexPage.earning.Lucky": "幸运值",
  "IndexPage.earning.LuckyTips": "当天矿池实际出块数/理论出块数",
  "IndexPage.earning.FrozenTip": "更多冻结中金额将在100个确认数后到账",
  "IndexPage.earning.FPPS": "已包含FPPS额外收益",

  "IndexPage.withdraw": "提现",
  "IndexPage.withdraw.Time": "提现时间",
  "IndexPage.withdraw.Fee": "手续费",
  "IndexPage.withdraw.Address": "提现地址",
  "IndexPage.withdraw.Status": "状态",
  "IndexPage.withdraw.AccountId": "交易ID",
  "IndexPage.withdraw.Paid": "已支付",
  "IndexPage.withdraw.NoPassed": "拒绝支付",
  "IndexPage.withdraw.ToBeProcess": "待处理",
  "IndexPage.withdraw.Processing": "处理中",

  "IndexPage.exchange.changeTime": "申请时间",
  "IndexPage.exchange.Exchanged": "兑换成功",
  "IndexPage.exchange.InExchange": "兑换中",
  "IndexPage.exchange.NoChange": "兑换失败",

  "IndexPage.Miner.ExportMiner": "导出矿工记录",
  "IndexPage.Miner.Miners": "矿工名",
  "IndexPage.Miner.online": "在线",
  "IndexPage.Miner.RejectRate": "拒绝率",

  "IndexPage.Miner.All": "全部",
  "IndexPage.Miner.Online": "在线",
  "IndexPage.Miner.Low": "低速",
  "IndexPage.Miner.Offline": "离线",

  "IndexPage.Miner.LastShare": "最近提交时间",
  "IndexPage.Miner.DefaultGroup": "默认分组",
  "IndexPage.Miner.AddGroup": "新增分组",
  "IndexPage.Miner.GroupName": "分组名称",
  "IndexPage.Miner.EditGroupName": "编辑分组",
  "IndexPage.Miner.PlaceholderGroup": "请输入分组名称",
  "IndexPage.Miner.LowMiner": "低速矿工：单个矿工的实时算力连续5次低于额定算力的80%",
  "IndexPage.Miner.Hashrate": "单个矿工额定算力",
  "IndexPage.Miner.HashrateTips": "请输入额定算力",
  "IndexPage.Miner.DelGroupTips1": "删除 ",
  "IndexPage.Miner.DelGroupTips2": " 分组后，矿工将分配至默认组中",
  "IndexPage.Miner.Continue": "继续",
  "IndexPage.Miner.InputMinerName": "请输入矿工名",
  "IndexPage.Miner.MoveTo": "移动到",
  "IndexPage.Miner.RunTime": "统计运行时长",
  "IndexPage.Miner.Time": "统计时间",
  "IndexPage.Miner.Electricity": "计算电费",
  "IndexPage.Miner.ChangeGroup": "变更矿工分组",
  "IndexPage.Miner.clear": "清空离线矿工",
  "IndexPage.Miner.clearText": "确定要清空离线矿工？",
  "IndexPage.Miner.moveToGroup": "请选择移动到的分组",

  "IndexPage.Exchange": "一键换币",
  "IndexPage.ToPlaceholder": "输入换币金额",
  "IndexPage.Ava": "可用提现金额为",
  "IndexPage.MinExchange": "，最小兑换额为 0.01 BTC",
  "IndexPage.ExpectdExchange": "预计可兑换",
  "IndexPage.ExchangeTip1": "矿池收取",
  "IndexPage.ExchangeTip2": "兑换手续费，实际兑换数量请以成交时兑换率为准",
  "IndexPage.CurrentExchangeRate": "实时兑换率",
  "IndexPage.ExchangeAll": "全部兑换",

  "IndexPage.BTCButton": "提现BTC",
  "IndexPage.BSVButton": "提现BSV",
  "IndexPage.LTCButton": "提现LTC",
  "IndexPage.DOGEButton": "提现DOGE",
  "IndexPage.fee": "手续费选择",
  "IndexPage.feeTips1": "单笔交易预计费用为",
  "IndexPage.widthDrawTips": "输入提现金额",
  "IndexPage.feeTips2": ",请以支付时为准",
  "IndexPage.TransferInfo": "请确认提现信息",
  "IndexPage.Amount": "提现金额",
  "IndexPage.AmountAll": "提现总额为",
  "IndexPage.widthDrawAll": "全部提现",
  "IndexPage.Address": "地址",
  "IndexPage.MoreSub": "多个子账户同时提现",
  "IndexPage.GoogleTitle": "谷歌验证码验证",
  "IndexPage.InputPlaceholder": "请输入google验证码",
  "IndexPage.WithdrawTips.title": "提现说明",
  "IndexPage.WithdrawTips.tips1": "为了您的资金安全，以下几种情况可能触发人工审核：",
  "IndexPage.WithdrawTips.tips2": "1.首次提现；",
  "IndexPage.WithdrawTips.tips3": "2.大额提现；",
  "IndexPage.WithdrawTips.tips4": "3.变更提现地址；",
  "IndexPage.WithdrawTips.tips5": "4.其它安全问题。",
  "IndexPage.WithdrawTips.tips6":
    "如果触发人工审核，我们会在2小时内完成审核，审核时间为工作日10:00~19:00 (UTC+8)。",
  "IndexPage.WithdrawTips.tips7": "非工作时间审核时间可能会延长，为了您的资金安全，敬请谅解。",

  "IndexPage.MiningSet": "挖矿设置",
  "IndexPage.AiMining": "智能托管",
  "IndexPage.MinerEarn": "收益币种",
  "IndexPage.IntelligentTips": "根据BTC与BSV收益变化，选择高收益币种挖矿",
  "IndexPage.TriggerValue": "触发值",
  "IndexPage.TriggerValueTip": "触发值必填",
  "IndexPage.TriggerValueTips": "当BTC与BSV价格差达到触发值时，进行切换。最小值为1%",
  "IndexPage.Payout": "收益模式",
  "IndexPage.AddressSet": "提现地址设置",
  "IndexPage.UseAccountAddr1": "使用主账户",
  "IndexPage.UseAccountAddr2": "提现地址",
  "IndexPage.withDrawTips1": "请勿填写",
  "IndexPage.withDrawTips2": "以外的地址或手机号码，以免提现至错误地址",
  "IndexPage.AlarmSetting": "监控报警设置",
  "IndexPage.AlarmSwitch": "监控开关",
  "IndexPage.HashRateAlarm": "算力报警",
  "IndexPage.ActiveMiners": "矿工数报警",
  "IndexPage.AlarmInterval": "报警间隔选择",
  "IndexPage.AlarmEmail": "邮箱联系人",
  "IndexPage.AlarmMobile": "手机联系人",
  "IndexPage.WatcherAccountList": "观察账户列表",
  "IndexPage.WatcherSetting": "观察者设置",
  "IndexPage.WatcherAccount": "添加观察者账户",
  "IndexPage.WatcherPlaceholder": "请输入观察者的完整账户名称，手机号码或邮箱",
  "IndexPage.AddedAccount": "已添加的观察者",
  "IndexPage.ShareLink": "共享链接",
  "IndexPage.WatcherTipsLeft": "观察者可以通过以上链接查看",
  "IndexPage.WatcherTipsRight": "的数据，但无法操作、修改你的子账户",
  "IndexPage.HashRateTooltip": "子账户算力低于设置值后，发送报警至设置的联系人",
  "IndexPage.ActiveMinersTooltip": "正常+低速矿工数低于设置值后，发送报警至设置的联系人",
  "IndexPage.AlarmIntervalTooltip": "根据设置的报警间隔，每日持续报警3次",
  "IndexPage.EmailTooltip": "用于接收报警邮件，最多可设置3个",
  "IndexPage.MobileTooltip": "用于接收报警短信，最多可设置3个",
  "IndexPage.HalfHour": "半小时",
  "IndexPage.AnHour": "1小时",
  "IndexPage.TwoHour": "2小时",
  "IndexPage.UseSub": "应用至全部子账户",
  "IndexPage.valueTips": "请输入1至100的值，精确到小数点后2位",
  "IndexPage.changeModeTip": "收益模式切换，在第二天8:00(UTC+8)生效",
  "IndexPage.changeMinerTip1": "收益模式将在第二日 UTC+8 8:00切换为",
  "IndexPage.changeMinerTip2": " ",
  "IndexPage.minute": "分钟",
  "IndexPage.hour": "小时",
  "IndexPage.day": "天",

  "IndexPage.Replenishment": "补账记录",
  "IndexPage.ReplenishmentTime": "补款时间",

  // 共享费率
  "IndexPage.DepositBSV": "注资BSV",
  "IndexPage.PayAddress": "付款地址",
  "IndexPage.NewAddress": "获取新地址",
  "IndexPage.Text1": "请将注资款转入上面地址",
  "IndexPage.Text2": "确认数超过3个时，注资款将同步至投资账户中。",
  "IndexPage.Text3": "转账后请等待约1分钟即可查询。",
  "WithDraw.low": "低",
  "WithDraw.height": "高",

  "IndexPage.noAccountTips1": "未创建子账户",
  "IndexPage.noAccountTips2": "请点击上方新增子账户按钮，创建子账户后开始挖矿",
  "IndexPage.steps1":
    "进入挖矿软件配置界面，填入您的子账户（密码建议留空）和挖矿地址，矿机将在五分钟内自动添加到矿池网站页面。",
  "mempool.indexPage.steps2":
    "矿机名规则为：子账户+英文句号+编号，例如，您的子账户是mempool, 可以设置矿机名为mempool.001、mempool.002，以此类推，一个矿机名对应一台矿机。",
  "mempool.indexPage.addressRule1":
    "中国用户挖矿地址可使用：ss.mempool.com:25     ss.mempool.com:443     ss.mempool.com:1800",
  "mempool.indexPage.addressRule2":
    "国际用户挖矿地址可使用：ss-eu.mempool.com:28080     ss-eu.mempool.com:28081     ss-eu.mempool.com:28085",
  "nourpool.indexPage.steps2":
    "矿机名规则为：子账户+英文句号+编号，例如，您的子账户是nourpool, 可以设置矿机名为nourpool.001、nourpool.002，以此类推，一个矿机名对应一台矿机。",
  "nourpool.indexPage.addressRule1":
    "中国用户挖矿地址可使用：ss.nourpool.io:25     ss.nourpool.io:443     ss.nourpool.io:1800",
  "nourpool.indexPage.addressRule2":
    "国际用户挖矿地址可使用：ss-eu.nourpool.io:25     ss-eu.nourpool.io:443     ss-eu.nourpool.io:1800",
  "exatoshi.indexPage.steps2":
    "矿机名规则为：子账户+英文句号+编号，例如，您的子账户是exatoshi, 可以设置矿机名为exatoshi.001、exatoshi.002，以此类推，一个矿机名对应一台矿机。",
  "exatoshi.indexPage.addressRule1":
    "用户挖矿地址可使用：ss.exatoshi.com:2333      ss.exatoshi.com:3333      ss.exatoshi.com:4333",

  // Report
  Electricity: "电费计算",
  ElectricTips: "配置功耗及电价，帮您计算矿工运行所消耗的电费，和矿场对账有依据",
  Miner: "矿工运行时长统计",
  MinerTips: "计算单个子账户的所有矿工的运行时长",
  MonthBill: "月账单",
  MonthTips: "每月10号为您生成上月子账户的账单明细记录",
  Count: "去计算",
  View: "查看",
  SubAccount: "子账户",
  MonthList: "月账单列表",
  Mail_receipt_billing_Settings: "邮件接收账单设置",
  Mail_receipt_bill: "邮件接收账单",
  To_receive_your_email: "接收邮箱：",
  Delete: "删除",
  Add: "添加",
  New_receiving_mailbox: "新增接收邮箱",
  GetReport: "生成报表",
  "Report.Mail.tableTip":
    "子账户的月账单，将在次月10日早上10点（北京时间）自动生成并提供下载。您可以设置邮件自动接收账单",
  "Report.Mail.Tips":
    "子账户的月账单，将在次月10日早上10点（北京时间）自动发送至设置的接收邮箱中，请注意查收",
  "Report.Mail.Tips1": "若未设置任何接收邮箱，本合约将不再自动发送月账单",
  "Report.Name": "名称",
  "Report.Time": "创建日期",
  "Report.Operation": "操作",
  "Report.Download": "下载",

  "Report.Select": "请选择",
  "Report.Elect": "导出电费报表",
  "Report.MinerName": "矿工名",
  "Report.RunTime": "导出运行时长报表",
  "Report.more": "更多统计结果，请",
  "Report.Elect.Price": "电价",
  "Report.Elect.PowerWaste": "功耗",
  "Report.Elect.Data": "统计日期",
  "Report.Elect.Other": "其他",
  "Report.Elect.RunTime": "运行时长（小时）",
  "Report.Elect.OtherFee": "其他费用（￥）",
  "Report.Elect.Cost": "费用总合（￥）",
  "Report.Blank": "统计间隔",

  // Tool
  "Tool.AppTips": "查看多账户挖矿详情，手动提现操作，矿机查看，子账户设置，观察者账户查看",
  "Tool.SmartAgent": "Mempool智能代理",
  "Tool.SmartAgentInfo": "针对大型矿场设计的stratum代理程序，可大幅提高矿场与矿池的通信效率",
  "Tool.MiningCal": "迷你挖矿计算器",
  "Tool.MiningInfo": "一款强大易用的挖矿收益计算器，输入算力，即看收益， 支持BSV、BTC",
  "Tool.link": "立即计算",
  "Tool.windows": "Windows 64",

  // Calculator
  "Cal.Hashrate": "有效算力",
  "Cal.PPS24": "PPS 24小时收益",
  "Cal.FPPS24": "FPPS 24小时收益",
  "Cal.About": "折合法币约",
  "Cal.Tips":
    "* 在上方输入有效算力，下方将显示理论获得收益；在下方输入理论收益，上方将显示有效算力。",
  "Cal.More": "更多设置",
  "Cal.Close": "收起设置",
  "Cal.Legal": "法币",
  "Cal.Price": "币价",
  "Cal.Diff": "难度",
  "Cal.EarnPPS": "收益比(PPS)",
  "Cal.EarnFPPS": "收益比(FPPS)",

  // Agent
  "Agent.TodayIncome": "今日收益",
  "Agent.Cumulative": "累计收益",
  "Agent.Text": "已计入收益-可提现金额中",
  "Agent.Accounts": "账户",
  "Agent.Types": "账号类型",
  "Agent.EarnedGains": "已抽成",
  "Agent.Gains": "预计抽成",
  "Agent.Remarks": "备注",
  "Agent.Agent": "代理",
  "Agent.Miner": "矿工",
  "Agent.Edit": "修改",
  "Agent.EditAccount": "修改账户",
  "Agent.Income": "理论收益",
  "Agent.Create": "创建代理",
  "Agent.BTCFee": "BTC手续费率",
  "Agent.BSVFee": "BSV手续费率",
  "Agent.LTCFee": "LTC手续费率",
  "Agent.DOGEFee": "DOGE手续费率",
  "Agent.Add": "确认创建",
  "Agent.Success": "创建成功！",
  "Agent.New": "继续创建",

  // Excel
  "Excel.amount": "金额",
  "Excel.withDraw.Way": "提现方式",
  "Excel.withDraw.Auto": "自动",
  "Excel.withDraw.Manual": "手动",
  "Excel.date": "日期",
  "Excel.BTCEarn": "BTC收益",
  "Excel.BTCOther": "BTC额外收益",
  "Excel.BSVEarn": "BSV收益",
  "Excel.BSVOther": "BSV额外收益",
  "Excel.BTCAmount": "BTC金额",
  "Excel.changeTime": "时间",
  "Excel.cahnegRate": "兑换率",
  "Excel.changeBSV": "成交BSV",
  "Excel.minerTitle": "矿工报表",
  "Excel.electricty": "电费统计报表",
  "Excel.runTime": "运行时长统计报表",
  "Excel.getReport": "请先生成报表",
  "Excel.report": "导出Excel",
  "Excel.feeBSV": "手续费(BSV)",
  "Excel.BTCTimeRange": "BTC收益列表时的记账时间范围",
  "Excel.BSVTimeRange": "BSV收益列表时的记账时间范围",

  // 活动字段
  ZeroRate: "0费率",
  "Affix.title1": "0费率挖BSV",
  "Affix.title2": "3.16～4.14",

  // v3.6
  "Loan.repayment": "贷款还款",
  "Loan.self electricity": "自缴电费",
  "Loan.electricity": "代缴电费",
  "Loan.freight": "运费",
  "Loan.maintenance": "维修费",
  "Loan.shelf": "上架费",
  "Loan.off shelf": "下架费",
  "Loan.purchase": "采购配件费",
  "Loan.other": "其他",

  // v3.8
  upTitle: "账户系统升级",
  upText1: "mempool矿池可以统一使用打点钱包登录了。",
  upText2: "矿池账户已为您自动升级，使用本账户可以直接登录打点钱包;",
  upText3: "若已有打点钱包账户且与矿池账户一致，请您使用打点钱包账户密码进行登录",
  upText4: "现在可以在地址设置中选择【提现至打点钱包】，不再需要设置提现地址。",
  know: "知道啦",

  // v3.8.1
  MSG_please_contact_customer_service: "账户未授权登录，请联系客服微信",

  // v4.0.0
  contactLTC: "需联系运营客服指定子账户开启LTC挖矿",

  /**
   *
   * MSG请一律放后面
   */
  MSG_withdrawal_type_not_supported_in_current_currency: "当前币种不支持的提现类型",
  MSG_unsupported_withdraw_type: "当前币种不支持的自动提现类型",
  MSG_wrong_withdraw_type: "错误的自动提现类型",
  MSG_input_username: "请输入登录名",
  MSG_input_password: "请输入密码",
  MSG_user_not_exist: "该用户不存在",
  MSG_login_fail: "登录失败， 请重试",
  MSG_incorrect_input_phone_number_or_mailbox_format: "输入手机号或邮箱格式有误",
  MSG_username_or_password_incorrect: "账户名或密码错误",
  MSG_wrong_withdraw_address_format: "提现地址格式错误",
  MSG_withdraw_fee_expire: "提交页面已超时，已重新加载最新费率",
  MSG_user_withdraw_address_not_set: "主账号提现地址未设置",
  MSG_wrong_username_format: "邮箱或手机号格式有误",
  MSG_wrong_password_format: "8-16位密码，至少包含一个字母、一个数字和一个特殊字符",
  MSG_wrong_username: "请输入邮箱或手机号",
  MSG_verify_pass: "验证通过",
  MSG_exchange_apply_success: "换币申请已提交",
  "MSG_amount_below_the_minimum_limit_0.005": "换币金额须大于0.005",
  MSG_user_failed_to_login_or_expired: "登录过期",
  MSG_login_out_seccess: "注销成功",
  MSG_input_verify_code: "请输入验证码",
  MSG_input_withdraw_address: "请输入收款地址",
  MSG_verify_code_incorrect: "验证码错误",
  MSG_edit_success: "修改成功",
  MSG_edit_fail: "修改失败",
  MSG_input_old_password: "请输入原密码",
  MSG_input_new_password: "请输入新密码",
  MSG_input_new_password_confirm: "请输入新密码确认",
  MSG_password_inconsistent: "密码不一致",
  MSG_wrong_withdraw_amount: "提现金额错误",
  MSG_amount_below_the_minimum_lit: "提现金额低于最小额",
  MSG_balance_insufficient: "余额不足",
  MSG_withdraw_apply_success: "提现请求已提交",
  MSG_catch_error: "系统错误",
  MSG_withdraw_address_not_set: "未设置提现地址",
  MSG_send_success: "发送成功",
  MSG_user_password_incorrect: "密码错误",
  "MSG_amount_below_the_minimum_limit_1.5": "提现金额须大于 1.5",
  "MSG_amount_below_the_minimum_limit_0.01": "提现金额须大于 0.01",
  "MSG_amount_below_the_minimum_limit_0.001": "提现金额须大于 0.001",
  MSG_user_not_exists: "用户不存在",
  MSG_register_success: "注册成功",
  MSG_add_success: "新增成功",
  MSG_edit_password_success: "重置密码成功",
  MSG_edit_password_faile: "重置密码失败",
  MSG_edit_password_fail: "重置密码失败",
  MSG_edit_password_failed: "重置密码失败",
  MSG_set_mobile_success: "设置手机号成功",
  MSG_set_email_success: "设置邮箱成功",
  MSG_user_mobile_already_exists: "用户已存在",
  MSG_pay_password_err: "支付密码错误", //Incorrect password!
  MSG_not_have_token_utx: "缺少 lack token!",
  MSG_trans_utx_faile: "转账执行失败", //Failed to transfer!
  MSG_not_have_token_addr: "付款地址获取失败", //Failed to get address.
  // new
  MSG_please_input_phone_number_or_email: "输入邮箱或者手机号",
  MSG_weixin_already_register_mobile: "当前微信已经注册了手机号",
  MSG_weixin_already_register_email: "当前微信已经注册了邮箱",
  MSG_user_email_already_exists: "用户邮箱已经存在",
  MSG_token_is_ok: "用户token有效",
  MSG_save_code_fail: "验证码发送失败",
  MSG_user_email_not_exists: "邮箱不存在",
  MSG_user_mobile_not_exists: "手机号码不存在",
  MSG_login_out_sucess: "退出登录成功",
  MSG_user_email_have: "当前用户已经绑定了邮箱",
  MSG_user_mobile_have: "当前用户已经绑定了手机号",
  MSG_set_info_success: "设置成功",
  MSG_set_userinfo_success: "更新用户信息成功",
  MSG_please_input_username: "请输入用户名称",
  MSG_need_public_key: "缺少公钥",
  MSG_userMnemonic_already_backup: "当前用户的助记词已经备份过了",
  MSG_pay_password_not_empty: "支付密码不能为空",
  MSG_addr_type_is_only_BSV_BTC: "只允许获取BSV或者BTC类型的地址",
  MSG_pay_amount_err: "付款金额为空或者不合法",
  MSG_pay_address_err: "付款地址为空或者不合法",
  MSG_transfer_to_user_receive_faile: "转账给用户失败",
  MSG_transfer_money_type_err: "用户领取失败",
  MSG_transfer_money_need_user_id: "当前币种转账必须传入收款用户 ID",
  MSG_pay_to_addr_user_id_err: "转账接收人错误",
  MSG_not_pay_to_user_self: "不能转账给自己",
  MSG_pay_password_empty: "支付密码为空",
  MSG_user_money_not_enough: "用户金额不足",
  MSG_token_is_empty: "code为空",
  MSG_code_is_err: "code错误",

  MSG_account_locked: "账号被锁定，请15分钟后重试",
  MSG_account_locked_three: "错误3次后锁定账号",
  MSG_account_locked_two: "错误2次后锁定账号",
  MSG_account_locked_one: "错误1次后锁定账号",

  MSG_send_mobile_success: "已发送验证码至注册手机号，请查收",
  MSG_send_email_success: "已发送验证码至注册邮箱，请查收",
  // 子账户创建提示
  MSG_user_name_type_incorrect: "子账户名应由4～30位的字母或数字组成，且只能由小写字母开头",
  MSG_do_faile: "创建失败， 请重试",
  MSG_the_name_of_the_input_sub_account_already_exists: "输入子账户名已经存在",
  MSG_user_is_have: "用户已存在",
  // MSG_exchange_success: "换币成功",
  MSG_send_fail: "发送失败",
  MSG_please_input_ga_code: "请输入谷歌验证码",
  MSG_wait_few_seconds_generate: "地址生成失败，请稍后重试",

  // 提现提示
  "MSG_amount_must_be_greater_than_0.0001": "提现金额必须大于0.0001",
  "MSG_amount_must_be_greater_than_0.01": "提现金额必须大于0.01",
  "MSG_amount_must_be_greater_than_1.5": "提现金额必须大于1.5",
  MSG_please_set_up_BTC_cash_address_first: "请先设置BTC提现地址",
  MSG_please_set_up_BSV_cash_address_first: "请先设置BSV提现地址",
  MSG_withdraw_success: "提现申请成功",
  MSG_withdraw_fail: "提现申请失败",
  MSG_exchange_success: "已提交兑换申请",
  MSG_exchange_fail: "兑换申请失败",
  MSG_exchange_amount_must_be_greater_than_0: "兑换金额低于0.01BTC",
  MSG_no_exchange_power: "未开通兑换权限",
  MSG_cash_amount_must_be_digits: "套现金额必须为数字",
  MSG_act_success: "操作成功",
  MSG_unable_to_get_total_account_number: "找不到主账户",
  MSG_amount_must_be_greater_than_0: "检查合法金额",
  MSG_cash_application_failed: "提现失败",
  MSG_account_balance_is_insufficient: "账户余额不足",
  MSG_failure_to_application: "生成套现申请记录失败",
  MSG_exchange_amount_not_enough: "兑换余额不足",
  MSG_please_input_bsv_address: "请输入BSV地址",
  MSG_please_input_btc_address: "请输入BTC地址",
  MSG_please_set_address: "请先设置提现地址",
  "MSG_amount_must_be_greater_than_0.00000546": "提现金额必须大于 0.00000546",
  MSG_input_the_correct_btc_fee_present: "BTC费率错误",
  MSG_input_the_correct_bsv_fee_present: "BSV费率错误",

  // 导出提示
  MSG_please_input_data_time: "请选择开始时间和结束时间",
  MSG_please_input_data_start: "请输入开始时间",
  MSG_please_input_data_end: "请输入结束时间",
  MSG_please_input_electric_charge: "请输入电费",
  MSG_please_input_power: "请输入功率",
  MSG_please_input_other: "其他费用格式错误",
  MSG_excel_fail: "导出Excel失败",
  MSG_please_input_mobile_or_email: "请输入邮箱或手机号",
  "MSG_exchange_amount_must_be_greater_than_0.01": "换币金额必须大于0.01",
  MSG_incorrect_email_format: "错误的邮箱",
  MSG_set_up_at_most_three_mibiles: "最多只能设置三个手机",
  MSG_incorrect_mobile_format: "错误的手机号",
  MSG_please_input_hash_rate_warn_value: "请输入正确的算力预警值",
  MSG_please_select_monitoring_mode: "请选择预警方式",
  MSG_please_input_subuser_id: "请输入子账户ID",

  //
  MSG_incorrect_password_format: "8-16位密码，至少包含一个字母、一个数字和一个特殊字符",
  MSG_name_size_less_than_50: "名字长度最长为50个字符",
  MSG_bind_fail: "绑定密钥失败",
  MSG_secret_expired: "密钥过期",
  MSG_ga_code_incorrect: "谷歌验证码错误",
  MSG_please_input_amount: "请输入金额",
  MSG_please_input_amount_btc: "请输入金额",
  MSG_please_input_amount_bsv: "请输入金额",
  MSG_balance_insufficient_fee: "账户余额不足以支付手续费",
  MSG_type_error: "资金池提现类型错误",
  MSG_amount_must_be_greater_than_smallest_amount: "提款金额低于最小额度",
  MSG_amount_must_be_greater_than_smallest_amount_btc: "提款金额低于最小额度0.0001BTC",
  MSG_amount_must_be_greater_than_smallest_amount_bsv: "提款金额低于最小额度0.0001BSV",
  MSG_fill: "请填写必填项",
  MSG_you_can_only_change_it_once_two_hour: "距离上次切换时间不足2小时，请稍后再试",
  MSG_withdraw_amount_illegal: "输入的金额格式错误，请重输",

  // 后端重构v3.4新增提示
  MSG_rated_power_err: "矿工额定算力输入错误",
  MSG_you_can_only_change_it_once_an_hour: "收益模式每小时只能切换一次",
  MSG_input_fee_rate_error: "格式错误",
  MSG_amount_percent_err: "请输入大于0，小于等于100的值",
  MSG_add_fail: "添加失败",
  MSG_data_type_err: "参数不合法",

  //v3.7.7
  MSG_hidden_sub: "请至少保留一个子账户",
  MSG_please_input_is_hidden: "缺少是否隐藏参数",
  MSG_please_input_setHidden_subuser_id: "请勾选子账号",

  // 旧版MSG
  MSG_no_user_id_modify: "缺少要修改的用户ID",
  MSG_user_phone_number_already_exists: "当前用户手机号已经存在了",
  MSG_please_input_user_name: "请输入用户名",
  MSG_no_user_id_to_delete: "缺少要删除的用户ID",
  MSG_user_phone_number_not_exist: "用户手机号不存在",
  MSG_lack_of_user_id_to_opened: "缺少要开通的用户ID",
  MSG_failure_to_deduct_money: "扣款失败，可能余额不足",
  MSG_mobile_not_be_empty: "mobile不能为空，请检查",
  MSG_id_is_empty: "id为空",
  MSG_no_user_id_to_modify: "缺少要修改的用户ID",
  MSG_no_content_to_modified: "缺少要修改的内容",
  MSG_incorrect_account_type: "账户类型不正确",
  MSG_lack_of_withdrawals_id: "缺少提现申请ID",
  MSG_please_input_info: "请输入打款交易号等备注信息",
  MSG_please_input_pay_password: "请输入支付密码",
  MSG_pay_password_is_incorrect: "支付密码不正确",
  MSG_failed_to_modify_audited: "修改数据库失败，可能信息不是待审核状态",
  MSG_admin_are_not_logged: "管理员未登录",
  MSG_do_successfully: "设置成功",
  MSG_please_enter_mobile: "请输入用户手机号",
  MSG_enter_user_permissions: "请输入用户权限标识",
  MSG_please_input_user_password: "请输入用户密码",
  MSG_add_user_success: "添加用户成功",
  MSG_add_user_fail: "添加用户失败",
  MSG_admin_not_logged: "管理员未登录",
  MSG_modify_user_success: "修改用户成功",
  MSG_modify_user_fail: "修改用户失败",
  MSG_user_does_not_exist: "用户信息不存在",
  MSG_delete_user_success: "删除用户成功",
  MSG_delete_user_fail: "删除用户失败",
  MSG_lack_of_user_id: "缺少用户ID",
  MSG_open_user_success: "开通用户成功",
  MSG_open_user_fail: "开通用户失败",
  MSG_input_the_correct_mobile: "请输入正确的mobile",
  MSG_mobile_is_wrong: "输入手机号格式有误，请检查",
  MSG_subaccount_is_incorrect: "输入的子账户id有误",
  MSG_please_input_correct_settlement: "请输入正确的结算方式",
  MSG_input_id_is_wrong: "输入的下级id有误，请检查",
  MSG_can_not_switch: "不能切换",
  MSG_do_not_switch_to_current_mode: "不可切换成当前方式",
  MSG_you_can_only_change_it_once_a_day: "一天只能修改一次",
  MSG_switch_error_please_try_again: "切换错误，请重试",
  MSG_input_at_least_one_modification_parameter: "请至少输入一个修改参数",
  MSG_input_the_correct_proportion: "请输入正确的抽成比例",
  MSG_get_sub_account_list: "获取子账户列表",
  MSG_input_login_name: "请输入登录名",
  MSG_sub_account_does_not_exist: "该子账户不存在，请检查",
  MSG_failed_to_modify_sub_account: "修改子账户信息失败",
  MSG_the_number_of_sub_accounts_is_incorrect: "获取子账户个数不正确，请检查",
  MSG_verify_fail: "验证失败",
  MSG_authentication_failed: "认证失败，请先登录",
  MSG_fail_please_check: "查询失败，请检查",
  MSG_send_successfully: "发送成功",
  MSG_id_incorrect: "输入id不正确，请检查",
  MSG_can_only_switch_to_pps: "只能切换为PPS",
  MSG_user_no_login: "用户未登陆",
  MSG_no_permission: "无创建权限",
  MSG_The_settlement_method_can_only_be_FPPS_or_FPPLNS: "结算方式只能为FPPS或FPPLNS",
  MSG_The_settlement_method_can_only_be_FPPS: "结算方式只能为FPPS",
  MSG_The_settlement_method_can_only_be_PPS: "结算方式只能为PPS",
  MSG_delete_faile: "删除用户失败",
  MSG_delete_sucess: "删除用户成功",
  MSG_the_old_password_entered_is_empty: "输入的旧密码为空，请检查",
  MSG_the_new_password_entered_is_empty: "输入的新密码为空，请检查",
  MSG_incorrectpasswordformat: "密码必须为8到16位,至少包含一个字母，一个数字、一个特殊字符",
  MSG_the_number_of_sub_users_is_not_compliant: "子用户个数不合规，请检查",
  MSG_please_input: "请输入信息",
  MSG_please_input_mobile_or_eamil: "请输入手机号或邮箱",
  MSG_input_the_proportion: "请输入手续费",
  MSG_please_input_right_user_type: "请输入正确的用户类型",
  MSG_input_the_correct_default_settlement_method: "请输入正确的默认结算方式",
  MSG_please_input_user_id: "请输入用户id",
  MSG_please_enter_verification_code: "请输入验证码",
  MSG_addr_incorrect: "要修改的地址类型不正确",
  MSG_can_not_get_mobile_or_email: "无法获取手机号或邮箱",
  MSG_please_input_days: "请输入要统计的天数",
  MSG_please_input_type: "请输入要修改的地址类型",
  MSG_please_enter_addr: "请输入提现地址",
  MSG_code_incorrect: "验证码错误",
  MSG_set_up_at_most_three_emails: "最多只能设置三个邮箱",
  MSG_send_verify_code_fail: "发送验证码失败",
  MSG_input_invite_code: "请输入邀请码",
  MSG_invite_code_incorrect: "邀请码错误",
  MSG_invite_code_expired: "邀请码已失效",
  MSG_user_name_length_incorrect: "子账户名长度应在4-30位之间",
  MSG_reset_password_fail: "重置密码失败",
  MSG_reset_password_success: "重置密码成功",
  MSG_rated_power_not_is_empty: "额定功率不允许为空",
  MSG_input_the_correct_auto_switch_rate: "触发值应为1%~100%之间",
  MSG_binding_user_inconsistent: "该微信没有与输入的矿池账户绑定，无法解绑",
  MSG_bound_user: "该账户已绑定其他微信号，请解绑后重试",
  MSG_email_format_incorrect: "邮箱格式错误",
};

export type Language = typeof Lang;
export default Lang;
